import { CheckCircleFill } from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router-dom";

const VOMRefundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const refundData = location?.state?.refundData;

  if (!refundData) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  return (
    <div className="bg-light min-vh-100 py-5 refund-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card border-0 shadow-sm p-4 p-md-5 rounded-3">
              {/* Success Icon */}
              <div className="text-center mb-4">
                <div className="success-icon-wrapper shadow-sm mx-auto">
                  <CheckCircleFill size={75} className="text-success" />
                </div>
              </div>

              {/* Header */}
              <div className="text-center mb-4">
                <h2 className="fw-bold mb-2">Refund Initiated</h2>
                <h5 className="text-dark mb-3">
                  Your VOM fee refund is being processed.
                </h5>
                <p className="text-muted small px-md-4">
                  Your VOM generation failed due to a system error. We apologize
                  for the inconvenience and have processed a full refund.
                </p>
              </div>

              {/* Details Table */}
              <div className="refund-details-box bg-white p-3 mb-4">
                <h6 className="fw-bold mb-3">Refund Details:</h6>
                <div className="table-responsive">
                  <table className="table table-borderless table-sm mb-0">
                    <tbody>
                      <tr>
                        <td className="text-muted py-2">Refund Amount:</td>
                        <td className="fw-bold py-2 text-end text-md-start">
                          $30.00 (USD)
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="text-muted py-2">Refund Method:</td>
                        <td className="fw-semibold py-2 text-end text-md-start">
                          {refundData.method}
                        </td>
                      </tr> */}
                      <tr>
                        <td className="text-muted py-2">Refund ID:</td>
                        <td className="fw-semibold py-2 text-end text-md-start">
                          {refundData.refundId}
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="text-muted py-2">Reference ID:</td>
                        <td className="fw-semibold py-2 text-end text-md-start text-break">
                          {refundData.referenceId}
                        </td>
                      </tr> */}
                      <tr>
                        <td className="text-muted py-2">Status:</td>
                        <td className="py-2 text-end text-md-start">
                          <span className="badge bg-success-light text-success fw-bold">
                            Processing
                          </span>
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="text-muted py-2">Refund Date:</td>
                        <td className="fw-semibold py-2 text-end text-md-start">
                          {refundData.date}
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Disclaimer */}
              {/* <p className="text-center text-muted small mb-4">
                Please allow 3-5 business days for the funds to reflect in your
                account depending on your bank.
              </p> */}

              {/* Action Buttons */}
              <div className="d-grid gap-5 d-md-flex justify-content-md-center my-5">
                <button
                  className="btn btn-primary px-4 py-4 d-flex align-items-center justify-content-center"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-clockwise me-2"></i> Retry VOM
                  Generation
                </button>
              </div>

              {/* Help Footer */}
              {/* <div className="mt-5 pt-3 border-top text-center">
                <a href="#" className="text-muted text-decoration-none small">
                  Need Help? Contact our support team
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Custom Scoped CSS */}
      <style>{`
        .refund-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #fff7f4, #fefefe);
          text-align: center;
          padding: 20px;
          animation: fadeIn 0.6s ease-out;
        }
        .success-icon-wrapper {
        //   background-color: #4bb543;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .bg-success-light {
          background-color: #e8f5e9;
        }
        .refund-details-box {
          border: 1px solid #f0f0f0;
          border-radius: 8px;
        }
        .table td {
          font-size: 0.95rem;
        }
        
      `}</style>
    </div>
  );
};

export default VOMRefundPage;
